import React, { useEffect, useState } from 'react';
import { Typography, Container, Button, IconButton, CircularProgress, TextField } from '@material-ui/core'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArchiveIcon from '@material-ui/icons/Archive';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import MaterialTable from 'material-table';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { IdentityActions, SalesPromotionActions, NotificationActions } from '../../../store';
import { FormControl, FormControlLabel, InputLabel, MenuItem, Select } from '@material-ui/core';

const style = theme => ({
    root: {
        height: '100%'
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const salesPromotionsSelector = (state) => state.SalesPromotions;
const IdentitySelector = (state) => state.Identity;

const SalesPromotionList = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const salesPromotionActions = bindActionCreators(SalesPromotionActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { list, nowWainting } = useSelector(salesPromotionsSelector);
    const { token, permissions } = useSelector(IdentitySelector);

    const { classes } = props;

    // QRコードサイズ
    const [qrSize, setQrSize] = React.useState('150');

    const listDefinition = {
        columns: [
            {
                // 加盟店名
                title: <FormattedMessage id="SalesPromotion.MerchantName" />,
                field: 'merchant_name',
                filtering: true
            },
            {
                // 店舗名
                title: <FormattedMessage id="SalesPromotion.ShopName" />,
                field: 'shop_name',
                filtering: true
            },
            {
                // 端末機識別番号
                title: <FormattedMessage id="SalesPromotion.TerminalId" />,
                field: 'terminal_id',
                filtering: true
            },
        ]
    };

    /**
     *
     * Similar to componentDidMount and componentDidUpdate:
     * 
     * 第2引数に[]を渡すとマウント時のみ呼び出される
     */
    useEffect(() => {
        // 初期レンダリングの時のみ販促物一覧を取得
        if (props.refresh == null || props.refresh == true) {
            // storeに販促物リストを要求
            // 販促物一覧を取得
            salesPromotionActions.listSalesPromotions(token)
                .then(data => {
                })
                .catch(e => {
                    notificationActions.showError(e.message);
                });
        }

    }, []);

    /**
     * 
     * ダウンロードボタン押下時の処理
     * 
     * @param data 選択された行のデータ 
     */
    const onDownloadClick = (data) => {
        // QRコードサイズに応じて、幅や余白を調整
        const size = parseInt(qrSize, 10);
        var fontSize = 16;
        var offsetSize = 60;
        var marginSize = 10;
        if (size == 50) {
            fontSize = 10;
            offsetSize = 40;
            marginSize = 20;
        }
        else if (size == 100) {
            fontSize = 12;
            offsetSize = 50;
            marginSize = 10;
        }
        else if (size >= 200) {
            fontSize = 20;
            offsetSize = 100;
            marginSize = 10;
        }
        const { createCanvas } = require('canvas');
        const canvasSize = size + offsetSize;
        const canvas = createCanvas(canvasSize, canvasSize);

        const QRCode = require('qrcode');
        const options = { width: canvasSize, margin: marginSize };
        QRCode.toCanvas(canvas, data.qr_code_data, options, function (error) {
            // 端末機識別番号を描画
            const ctx = canvas.getContext('2d');
            ctx.font = `${fontSize}px Impact`;
            ctx.fillStyle = 'black';
            ctx.fillText(data.terminal_id, 1, fontSize);
            // アンカータグを作成
            var a = document.createElement('a');
            // キャンパスをデータURIに変換しhrefへセット
            var url = canvas.toDataURL();
            a.href = url;
            // ダウンロード時のファイル名を指定
            var fileFName = `QRCODE_${data.terminal_id}.png`;
            a.download = fileFName;
            // クリックイベントを発生させる（ダウンロード）
            a.click();
            // メッセージ表示
            notificationActions.showSuccess(`ダウンロードしました。（${fileFName}）`);
        });
    }

    /**
     *
     * QRコードサイズ変更時の処理
     *
     */
    const handleQrSizeChange = (event) => {
        setQrSize(event.target.value);
    };

    const placeholder = <FormattedMessage id="Table.Action" />;

    return (
        <Container className={classes.root} maxWidth={false}>
            <MaterialTable
                title={<Typography component="h1" variant="inherit">{<FormattedMessage id="SalesPromotion.Title" />}</Typography>}
                columns={listDefinition.columns}
                data={list}
                options={{
                    search: false,
                    filtering: true,
                    actionsColumnIndex: -1
                }}
                localization={{
                    body: {
                        emptyDataSourceMessage: <FormattedMessage id="Table.EmptyDataSourceMessage" />
                    },
                    header: {
                        actions: <FormattedMessage id="SalesPromotion.Download" />
                    },
                }}
                components={{
                    // 右端のアクションボタン列（QRコードのダウンロードボタン、QRコード縦横サイズ選択リスト）
                    Action: actionProps => {
                        if (actionProps.action.tooltip !== "Add") {
                            return (
                                <IconButton aria-label="detail" onClick={() => onDownloadClick(actionProps.data)}>
                                    <ArchiveIcon />
                                </IconButton>
                            )
                        } else {
                            return (
                                <div style={{ padding: 10 }}>
                                    <FormControl fullWidth variant="outlined" className={classes.formControl}>
                                        <InputLabel id="qr-code-label"><FormattedMessage id={"SalesPromotion.QrCodeSize"} /></InputLabel>
                                        <Select
                                            label={<FormattedMessage id={"SalesPromotion.QrCodeSize"} />}
                                            value={qrSize}
                                            onChange={handleQrSizeChange}
                                            inputProps={{
                                                name: 'qrcode-width',
                                                id: 'qrcode-width',
                                            }}
                                        >
                                            <MenuItem value="50">50ピクセル</MenuItem>
                                            <MenuItem value="100">100ピクセル</MenuItem>
                                            <MenuItem value="150">150ピクセル</MenuItem>
                                            <MenuItem value="200">200ピクセル</MenuItem>
                                            <MenuItem value="250">250ピクセル</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            )
                        }
                    }
                }}
                editable={{
                    onRowAdd: newData => { },
                    onRowUpdate: (newData, oldData) => { }
                }}
            />
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(SalesPromotionList);
